import script from "./TargetCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./TargetCard.vue?vue&type=script&setup=true&lang=ts"

export default script